export const contentTableConfig = {
  title: '访问记录',
  propList: [
    {
      prop: 'channelName',
      label: '直播间',
      minWidth: '120',
      slotName: 'channel'
    },
    { prop: 'pv', label: '访问次数(pv)', minWidth: '80' },
    {
      prop: 'uv',
      label: '客户数量(uv)',
      minWidth: '80'
    },
    {
      prop: 'ip',
      label: 'ip数量',
      minWidth: '80'
    },
    {
      prop: 'duration',
      label: '访问总时长',
      minWidth: '120',
      slotName: 'duration'
    },
    {
      prop: 'continueAttendNum',
      label: '持续听课三天以上且未成交的客户',
      minWidth: '120'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
